import { render, staticRenderFns } from "./orderRecord.vue?vue&type=template&id=bd30b66a"
import script from "./orderRecord.vue?vue&type=script&lang=js"
export * from "./orderRecord.vue?vue&type=script&lang=js"
import style0 from "./orderRecord.vue?vue&type=style&index=0&id=bd30b66a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports